import React, { startTransition } from "react";
import { useNavigate } from "react-router-dom";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import DocumentsIcon from "@mui/icons-material/Description";
import PolicyIcon from "@mui/icons-material/Policy";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import { useTheme, useMediaQuery } from "@mui/material";
import useStore from "hooks/useStore";

const PublicMenu = ({ toggleDrawer }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const isUserAdministrator = useStore((state) => state.isUserAdministrator)();
  const isUserPublic = useStore((state) => state.isUserPublic)();

  const onMenuItemClick = (path) => {
    if (isMobile) {
      toggleDrawer();
    }
    startTransition(() => navigate(path));
  };

  return (
    <React.Fragment>
      {isUserAdministrator && (
        <ListSubheader component="div" inset>
          Public
        </ListSubheader>
      )}
      {isUserPublic && (
        <>
          <ListItemButton onClick={() => onMenuItemClick("/public")}>
            <ListItemIcon>
              <DocumentsIcon />
            </ListItemIcon>
            <ListItemText primary="My Contracts" />
          </ListItemButton>
          <ListItemButton onClick={() => onMenuItemClick(`/view-user-manual`)}>
            <ListItemIcon>
              <AutoStoriesIcon />
            </ListItemIcon>
            <ListItemText primary="View User Manual" />
          </ListItemButton>
          <ListItemButton onClick={() => onMenuItemClick("/view-tnc")}>
            <ListItemIcon>
              <PolicyIcon />
            </ListItemIcon>
            <ListItemText primary="Terms & Conditions" />
          </ListItemButton>
        </>
      )}
    </React.Fragment>
  );
};

export default PublicMenu;
